import { ref, computed } from "vue";
import axios from "@/includes/connection";

export function useEventForm() {
  const places = ref([]);
  const kinds = ref([]);
  const orienteds = ref([]);
  const listEnrollment = ref([]);

  const today = computed(() => {
    const d = new Date();
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const day = d.getDate().toString().padStart(2, "0");
    return `${d.getFullYear()}-${month}-${day}`;
  });

  const loadPlaces = async () => {
    try {
      const response = await axios.get("/place");
      if (response.data) {
        places.value = response.data.filter((place) => place.state);
      }
    } catch (error) {
      console.error("Error loading places:", error);
      throw error;
    }
  };

  const loadKindEvents = async () => {
    try {
      const response = await axios.get("/kind-event");
      if (response.data) {
        kinds.value = response.data.filter((kind) => kind.state);
      }
    } catch (error) {
      console.error("Error loading kind events:", error);
      throw error;
    }
  };

  const loadOrienteds = async () => {
    try {
      const response = await axios.get("/kind-event/oriented");
      if (response.data) {
        orienteds.value = response.data;
      }
    } catch (error) {
      console.error("Error loading orienteds:", error);
      throw error;
    }
  };

  const loadEnrollmentForms = async () => {
    try {
      const response = await axios.get("/enrollment-form/");
      if (response.data) {
        listEnrollment.value = response.data.filter((item) => item.state);
      }
    } catch (error) {
      console.error("Error loading enrollment forms:", error);
      throw error;
    }
  };

  const loadAllData = async () => {
    await Promise.all([
      loadPlaces(),
      loadKindEvents(),
      loadOrienteds(),
      loadEnrollmentForms(),
    ]);
  };

  const getPlaceCapacity = (placeId) => {
    const place = places.value.find((p) => p.id === parseInt(placeId));
    return place ? place.capacity : 0;
  };

  return {
    places,
    kinds,
    orienteds,
    listEnrollment,
    today,
    loadPlaces,
    loadKindEvents,
    loadOrienteds,
    loadEnrollmentForms,
    loadAllData,
    getPlaceCapacity,
  };
}
